import React from 'react';
import clsx from 'clsx';

import { AccordionCard } from 'App/DetailsPage/common/AccordionCard/AccordionCard';
import useWindowDimensions from 'App/hooks/windowDimensions.hooks';
import { screenBreakpoints } from 'config/track-config';
import { trackInteraction } from 'store/analytics/analytics.thunks';
import { useAppDispatch } from 'store/store';

import styles from './AccordionWrapper.module.scss';

export interface AccordionWrapperProps {
  id: string;
  heading: string;
  isGroupLast?: boolean;
}

const AccordionWrapper: React.FC<AccordionWrapperProps> = ({ id, heading, isGroupLast = false, children }) => {
  const { width } = useWindowDimensions();
  const dispatch = useAppDispatch();
  if (width < screenBreakpoints.lg) {
    const accordionArgs = {
      id: id,
      heading: <span>{heading}</span>,
      children: children,
      icon: null,
    };
    return (
      <AccordionCard
        className={clsx({ [styles.isGroupLast]: isGroupLast })}
        {...accordionArgs}
        onToggle={(isOpen) => {
          if (!isOpen) dispatch(trackInteraction(`view ${heading.toLowerCase()}`));
        }}
      />
    );
  } else {
    return <>{children}</>;
  }
};

export default AccordionWrapper;
